import { assets, type ImageAsset } from '@/assets';
import type { Orientation } from '@/lib/orientation';
import type { GlowLight } from '@/pixi/effects/GlowLights';

/** A background painting and the glows placed on its light sources, in image pixels. */
export interface SceneView {
  background: ImageAsset;
  lights: readonly GlowLight[];
}

/** A location with art for each layout orientation. */
export type Scene = Record<Orientation, SceneView>;

const GLOBE_BLUE = 0x3fb8ff;

/** A large, slowly breathing halo over a painted globe. */
const globeHalo = (x: number, y: number, radius: number): GlowLight => ({
  x,
  y,
  width: radius * 2.6,
  height: radius * 2.6,
  color: GLOBE_BLUE,
  intensity: 0.32,
  motion: 'pulse',
});

/** Agency command center: a glowing world globe above the briefing floor. */
export const commandCenter: Scene = {
  portrait: {
    background: assets.backgrounds.commandCenterPortrait,
    lights: [globeHalo(464, 367, 195)],
  },
  landscape: {
    background: assets.backgrounds.commandCenterLandscape,
    lights: [globeHalo(840, 292, 205)],
  },
};
